import * as React from 'react';
import { Link } from 'react-router-dom';

import logoUrl from './logo_white.svg';

const CO4_LOGO_PATH =
  'M22.451,13.947V13.9a1.949,1.949,0,0,1,1.9-2.047,2.009,2.009,0,0,1,1.939,2.09v.043a1.949,1.949,0,0,1-1.9,2.047,2.009,2.009,0,0,1-1.939-2.09M38.927,8.075v4.707H33.384ZM0,11.2v.061A10.944,10.944,0,0,0,11.139,22.4a11.3,11.3,0,0,0,7.055-2.159,9.351,9.351,0,0,0,6.1,2.138,9.107,9.107,0,0,0,7.651-3.833h6.978v3.776h7.318V18.548H50V12.769H46.246V.176H38.193L29.917,7.23a9.466,9.466,0,0,0-5.559-1.713,8.831,8.831,0,0,0-8.8,6.321h0l0,.01c-.051.191-.1.386-.133.581a5.548,5.548,0,0,1-.869,2.043,4.485,4.485,0,0,1-.862.793l-.035.024a4.02,4.02,0,0,1-2.331.667c-2.363,0-4.02-1.964-4.02-4.756v-.062c0-2.577,1.6-4.695,4.02-4.695.064,0,.126,0,.188,0h0l.029,0q.173.007.338.026A5.644,5.644,0,0,1,15.548,8.4a10.318,10.318,0,0,1,5.008-3.764A10.512,10.512,0,0,0,11.416,0,11.1,11.1,0,0,0,0,11.2';

export interface LogoProps {
  /** `onLight` — solid brand blue for light headers (uses `currentColor` + `--sl-background-blue`). */
  variant?: 'default' | 'onLight';
}

const LogoMarkOnLight: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 22.402"
    className={className}
    width={50}
    height={22.402}
    aria-hidden>
    <g transform="translate(2614 -18525)">
      <path d={CO4_LOGO_PATH} fill="currentColor" transform="translate(-2614 18525)" />
    </g>
  </svg>
);

export const Logo: React.FC<LogoProps> = ({ variant = 'default' }) => (
  <Link
    to="/"
    className={`logo-link${variant === 'onLight' ? ' logo-link--on-light' : ''}`}
    {...(variant === 'onLight' ? { 'aria-label': 'co4 Logo' } : {})}>
    <div className="logo-wrapper">
      {variant === 'onLight' ? (
        <LogoMarkOnLight className="header-logo" />
      ) : (
        <img src={logoUrl} alt="co4 Logo" className="header-logo" />
      )}
    </div>
  </Link>
);
